<template>
  <div class="home">
    <HeaderEntrance />
    <FeatureHeadlines />
  </div>
</template>

<script>
import HeaderEntrance from "@/components/HeaderEntrance";
import FeatureHeadlines from "@/components/FeatureHeadlines";

export default {
  components: {
    HeaderEntrance,
    FeatureHeadlines
  }
};
</script>
